// Libraries
import { Icon } from '@chakra-ui/react';
// Types
import { EyeIconPaths, EyeIconProps, EyeIconType, EyeIconViewBox } from './EyeIcon.type';

/**
 * Component that renders the Eye Icon.
 * @param {EyeIconProps} props - The EyeIconProps for the EyeIcon component.
 * @param {EyeIconType} props.iconType - The icon type for the EyeIcon component.
 * @returns {ReactElement} The GraphIcon component.
 */
export const EyeIcon = (props: EyeIconProps) => {
  const { iconType = EyeIconType.CLOSE, ...rest } = props;
  return (
    <Icon viewBox={EyeIconViewBox[iconType]} {...rest} id='eye'>
      <path d={EyeIconPaths[iconType]} fill='currentColor' />
    </Icon>
  );
};
